/**
 * API for login
 */
import request from "./index";

/**
 * Create random code
 * @returns Random code
 */
export function createRandomCode() {
  return request({
    url: "code",
    method: "GET",
  });
}

/**
 * Login
 * @param {string} fromData.username - username
 * @param {string} fromData.password - password
 */
export function login(fromData) {
  return request({
    url: "auth/login",
    method: "POST",
    data: fromData,
  });
}

/**
 * Get login info
 */
export function getLoginInfo() {
  return request({
    url: "system/user/getInfo",
    method: "GET",
  });
}

/**
 * Get router
 */
export function getRouter() {
  return request({
    url: "system/menu/getRoutersForTygx",
    method: "GET",
  });
}

/**
 * Logout
 */
export function logout() {
  return request({
    url: "auth/logout",
    method: "DELETE",
  });
}

/**
 * userInfo
 */
export function userInfo() {
  return request({
    url: "zjwyArchive/staffFile/userInfo",
    method: "GET",
  });
}
